export default __webpack_public_path__ + "static/media/pin.20920e1c.svg";